import React from 'react';
import { useHistory } from 'react-router-dom';
import { Image, Typography } from 'lib/components';
import SideNavLinkList from './SideNavLinkList';
import { SIDE_NAV_ITEMS, SIDE_NAV_EXTRA_ITEMS } from 'lib/util';
import { useSelectAuthorization } from 'store';
import classes from './index.module.scss';

/**
 * SideNav component
 * Renders the main navigation sidebar for desktop view
 * Includes main menu, job creation button, and extra links
 *
 * @returns {JSX.Element} - Rendered component
 */
const SideNav = () => {
	// Router history for navigation
	const history = useHistory();
	// User permissions from Redux
	const { canCreateJob } = useSelectAuthorization();

	return (
		<div className={classes['sideNav']}>
			{/* Main menu section header */}
			<Typography className={classes['sideNav-title']} variant="subheading2" color="primary">
				MENU
			</Typography>
			{/* Main navigation links */}
			<div className={classes['sideNav-nav']} style={{ marginBottom: canCreateJob ? 0 : 'auto' }}>
				<SideNavLinkList list={SIDE_NAV_ITEMS} />
			</div>

			{/* Add New Job button - only shown if user has permission */}
			{canCreateJob && (
				<button className={classes['sideNav-addNewDispatch']} onClick={() => history.push('/jobs/create')}>
					<Typography className={classes['sideNav-addNewDispatch-title']} variant="p">
						Add New Job
					</Typography>
					<a className={classes['sideNav-addNewDispatch-button']}>
						<Image src={'icPlusPrimary'} alt="plus icon" />
					</a>
				</button>
			)}

			{/* Extra menu section header */}
			<Typography className={classes['sideNav-title']} variant="subheading2" color="primary">
				EXTRA
			</Typography>
			{/* Extra navigation links */}
			<div className={classes['sideNav-nav']}>
				<SideNavLinkList list={SIDE_NAV_EXTRA_ITEMS} />
			</div>
		</div>
	);
};

export default SideNav;
